import React, {Fragment} from "react";
import {parseToEnRemoveComma} from "../../utils/CommaSeparator";

const CellValue = (props) => {
  const {formatter, editor, value, cell, cellEdited} = props;

  if (editor || formatter) {
    if (editor === "number") {
      return (
        <input
          type="text"
          className="hoverCellInNewTable"
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#ffffff00",
            border: "none",
            padding: 3,
            textAlign: "center",
          }}
          value={formatter ? formatter(cell) : value}
          onClick={(e) => e.target.select()}
          onChange={(e) => {

            let parsedValue = parseToEnRemoveComma(e.target.value);
            console.log(parsedValue)
            // e.target.value = parsedValue.replace(/[^0-9.]/g, '');
            cellEdited(e, cell);


          }
          }
        />
      );
    }
    if (editor === "text") {
      return (
        <input
          type="text"
          className="hoverCellInNewTable"
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#ffffff00",
            border: "none",
            padding: 3,
            textAlign: "center",
          }}
          value={formatter ? formatter(cell) : value}
          onClick={(e) => e.target.select()}
          onChange={(e) => {
            cellEdited(e, cell);

          }}
        />
      );
    }

    if (formatter) {
      if (formatter === "buttonCross") {
        return (
          <div
            style={{
              color: "red",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            &#215;
          </div>
        );
      } else if (formatter === "checkBox") {
        return (
          <input
            type="checkbox"
            style={{
              backgroundColor: "#ffffff00",
              border: "none",
              textAlign: "center",
            }}
            checked={value}
            onChange={(e) => {
              cellEdited(e, cell);
            }}
          />
        );
      } else {
        return formatter(cell);
      }
    }
  }

  return <Fragment>{value}</Fragment>;
};

export default React.memo(CellValue);